import "./styles.scss";

import type { JSX } from "react";

export default function Wallpaper(): JSX.Element {
  return <div className="wallpaper" data-testid="wallpaper"></div>;
}
